import { styled } from '@/styled-system/jsx';

export const StyledPhoneLink = styled('a', {
  base: {
    color: 'hpxTeal500',
    textDecoration: 'none',
    cursor: 'pointer',
    transitionProperty: 'color',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'ease',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',

    '&:hover': {
      color: 'hpxTeal600',
      textDecoration: 'underline',
    },

    '&:active': {
      color: 'hpxTeal700',
    },

    '&:focus': {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: 'hpxTeal500',
      outlineOffset: '2px',
    },
  },
});
